import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IACOPY_FEEDBACK_CATEGORIES } from '../../models/ia-generation-outcome.model';

export interface IACopyFeedbackDialogData {
  initialCategory?: string;
  initialNotes?: string;
  submitLabel?: string;
  showSkip?: boolean;
}

export interface IACopyFeedbackDialogResult {
  notes: string;
  category?: string;
}

@Component({
  selector: 'app-ia-copy-feedback-dialog',
  templateUrl: './ia-copy-feedback-dialog.component.html',
  styleUrls: ['./ia-copy-feedback-dialog.component.scss'],
})
export class IACopyFeedbackDialogComponent {
  readonly feedbackCategories = IACOPY_FEEDBACK_CATEGORIES;
  readonly formGroup: FormGroup;
  readonly submitLabel: string;
  readonly showSkip: boolean;

  constructor(
    private matDialogRef: MatDialogRef<IACopyFeedbackDialogComponent, IACopyFeedbackDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: IACopyFeedbackDialogData
  ) {
    this.submitLabel = this.data.submitLabel?.trim() || 'Submit feedback';
    this.showSkip = this.data.showSkip !== false;
    this.formGroup = new FormGroup({
      category: new FormControl(this.data.initialCategory ?? '', { nonNullable: true }),
      notes: new FormControl(this.data.initialNotes ?? '', { nonNullable: true }),
    });
  }

  close(): void {
    this.matDialogRef.close(undefined);
  }

  skip(): void {
    this.matDialogRef.close({ notes: '', category: undefined });
  }

  submit(): void {
    const category = (this.formGroup.get('category')?.value ?? '').trim() || undefined;
    const notes = (this.formGroup.get('notes')?.value ?? '').trim();
    this.matDialogRef.close({ notes, category });
  }
}
